import { render, staticRenderFns } from "./addresses.vue?vue&type=template&id=0d2c6958"
import script from "./addresses.vue?vue&type=script&lang=js"
export * from "./addresses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports